
// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAprvXpiwo-ot618UulfZmETMdmYq7tSgc",
  authDomain: "mycloset-ece5e.firebaseapp.com",
  projectId: "mycloset-ece5e",
  storageBucket: "mycloset-ece5e.appspot.com",
  messagingSenderId: "204740269523",
  appId: "1:204740269523:web:5bed1c0f4f214eb5ebcb26",
  measurementId: "G-JV4CB0YV02",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export default app;

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);